import { useTabs } from "@commonlibs";
import { usePartnerFindAllInfinity } from "features/partners/hooks/usePartnerFindAllInfinity";
import { PartnerType } from "ui/partners/types/PartnerType";

export default function usePartnerList() {
    const [index] = useTabs();
    const partnerType = index === 0 ? PartnerType.PHYSICAL_STORE : PartnerType.ONLINE_STORE;
    const { data, isLoading, fetchNextPage, hasNextPage, isFetching } = usePartnerFindAllInfinity({ type: partnerType });
    const isPreviousData = data?.pages[0].items.length !== 0;

    return {
        data,
        isLoading: (isFetching && isPreviousData) || isLoading,
        fetchNextPage,
        hasNextPage,
    };
}
